import { globalHistory } from "@reach/router";

export enum TRACKING_ID {
  CookiePro = '01905b6c-bbad-7965-ab69-72252931afa7',
  SegmentDev = 'qsaDIDtHqCFMG5XJX706sYVDVRTWwEdp',
  SegmentProd = 'ItwFBwQFLVFBWftTS6NO8pHY9tDHw93w',
  GoogleAnalytics = 'G-4V17FFVS2W',
  GoogleAds = 'AW-307007418',
  Facebook = '2357677947784430',
  Intercom = 'hvj2kcvi',
  VWO = '893443',
  ApolloIO = '66a792498eda6303ef5ebac4'
}

export const MARKETING_COOKIE = 'PerpetuaSessionData';

export const IS_CHINA_SITE = globalHistory && globalHistory.location?.host === 'perpetua.com.cn';

export const IS_PRODUCTION = globalHistory && globalHistory.location?.host === 'perpetua.io';

export const COOKIEPRO_ID = IS_PRODUCTION ? TRACKING_ID.CookiePro : `${TRACKING_ID.CookiePro}-test`;

export const SEGMENT_ID = IS_PRODUCTION ? TRACKING_ID.SegmentProd : TRACKING_ID.SegmentDev;

export const COOKIEPRO_SETTINGS = {
  'data-domain-script': COOKIEPRO_ID,
  'data-document-language': true,
  'crossorigin': 'anonymous',
};

export const TRACKING_LIBS = {
  CookieProTemplates: 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js',
  CookieProAutoblock: `https://cdn.cookielaw.org/consent/${COOKIEPRO_SETTINGS['data-domain-script']}/OtAutoBlock.js`,
  Segment: `!function(){var e=window.analytics=window.analytics||[];if(!e.initialize)if(e.invoked)window.console&&console.error;else{e.invoked=!0,e.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on","addSourceMiddleware","addIntegrationMiddleware","setAnonymousId","addDestinationMiddleware"],e.factory=function(t){return function(){var a=Array.prototype.slice.call(arguments);return a.unshift(t),e.push(a),e}};for(var t=0;t<e.methods.length;t++){var a=e.methods[t];e[a]=e.factory(a)}e.load=function(t,a){var n=document.createElement("script");n.type="text/javascript",n.async=!0,n.src="https://cdn.segment.com/analytics.js/v1/"+t+"/analytics.min.js";var r=document.getElementsByTagName("script")[0];r.parentNode.insertBefore(n,r),e._loadOptions=a},e._writeKey="${SEGMENT_ID}",e.SNIPPET_VERSION="4.15.3",e.load("${SEGMENT_ID}")}}();`,
  Intercom: `var IntercomLoadUseCases=["mousemove","scroll","touchstart"],IntercomLoader=function(){window.intercomSettings={api_base:"https://api-iam.intercom.io",app_id:"${TRACKING_ID.Intercom}"};var e=window,t=e.Intercom;if("function"==typeof t)t("reattach_activator"),t("update",e.intercomSettings);else{var r=function(){r.c(arguments)};r.q=[],r.c=function(e){r.q.push(e)},e.Intercom=r;var o=document.createElement("script");o.type="text/javascript",o.async=!0,o.src="https://widget.intercom.io/widget/${TRACKING_ID.Intercom}";var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(o,a)}IntercomLoadUseCases.forEach(e=>{window.removeEventListener(e,IntercomLoader)})};IntercomLoadUseCases.forEach(e=>{window.addEventListener(e,IntercomLoader,{once:!0})});`,
  Youtube: `var YT,YTConfig,scriptUrl="https://www.youtube.com/s/player/d759e46a/www-widgetapi.vflset/www-widgetapi.js";try{var ttPolicy=window.trustedTypes.createPolicy("youtube-widget-api",{createScriptURL:function(t){return t}});scriptUrl=ttPolicy.createScriptURL(scriptUrl)}catch(t){}window.YT||(YT={loading:0,loaded:0}),window.YTConfig||(YTConfig={host:"https://www.youtube.com"}),YT.loading||(YT.loading=1,function(){var t=[];YT.ready=function(e){YT.loaded?e():t.push(e)},window.onYTReady=function(){YT.loaded=1;for(var e=0;e<t.length;e++)try{t[e]()}catch(t){}},YT.setConfig=function(t){for(var e in t)t.hasOwnProperty(e)&&(YTConfig[e]=t[e])};var e=document.createElement("script");e.type="text/javascript",e.id="www-widgetapi-script",e.src=scriptUrl,e.async=!0;var r=document.currentScript;if(r){var i=r.nonce||r.getAttribute("nonce");i&&e.setAttribute("nonce",i)}var n=document.getElementsByTagName("script")[0];n.parentNode.insertBefore(e,n)}());`,
  Vimeo: `https://player.vimeo.com/api/player.js`,
  GtagLibrary: `https://www.googletagmanager.com/gtag/js?id=${TRACKING_ID.GoogleAnalytics}`,
  GtagFunction: 'window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments)};',
  VWO: `window._vwo_code || (function() {
    var account_id=${TRACKING_ID.VWO},
    version=2.1,
    settings_tolerance=2000,
    hide_element='body',
    hide_element_style = 'opacity:0 !important;filter:alpha(opacity=0) !important;background:none !important',
    /* DO NOT EDIT BELOW THIS LINE */
    f=false,w=window,d=document,v=d.querySelector('#vwoCode'),cK='_vwo_'+account_id+'_settings',cc={};try{var c=JSON.parse(localStorage.getItem('_vwo_'+account_id+'_config'));cc=c&&typeof c==='object'?c:{}}catch(e){}var stT=cc.stT==='session'?w.sessionStorage:w.localStorage;code={use_existing_jquery:function(){return typeof use_existing_jquery!=='undefined'?use_existing_jquery:undefined},library_tolerance:function(){return typeof library_tolerance!=='undefined'?library_tolerance:undefined},settings_tolerance:function(){return cc.sT||settings_tolerance},hide_element_style:function(){return'{'+(cc.hES||hide_element_style)+'}'},hide_element:function(){if(performance.getEntriesByName('first-contentful-paint')[0]){return''}return typeof cc.hE==='string'?cc.hE:hide_element},getVersion:function(){return version},finish:function(e){if(!f){f=true;var t=d.getElementById('_vis_opt_path_hides');if(t)t.parentNode.removeChild(t);if(e)(new Image).src='https://dev.visualwebsiteoptimizer.com/ee.gif?a='+account_id+e}},finished:function(){return f},addScript:function(e){var t=d.createElement('script');t.type='text/javascript';if(e.src){t.src=e.src}else{t.text=e.text}d.getElementsByTagName('head')[0].appendChild(t)},load:function(e,t){var i=this.getSettings(),n=d.createElement('script'),r=this;t=t||{};if(i){n.textContent=i;d.getElementsByTagName('head')[0].appendChild(n);if(!w.VWO||VWO.caE){stT.removeItem(cK);r.load(e)}}else{var o=new XMLHttpRequest;o.open('GET',e,true);o.withCredentials=!t.dSC;o.responseType=t.responseType||'text';o.onload=function(){if(t.onloadCb){return t.onloadCb(o,e)}if(o.status===200){_vwo_code.addScript({text:o.responseText})}else{_vwo_code.finish('&e=loading_failure:'+e)}};o.onerror=function(){if(t.onerrorCb){return t.onerrorCb(e)}_vwo_code.finish('&e=loading_failure:'+e)};o.send()}},getSettings:function(){try{var e=stT.getItem(cK);if(!e){return}e=JSON.parse(e);if(Date.now()>e.e){stT.removeItem(cK);return}return e.s}catch(e){return}},init:function(){if(d.URL.indexOf('__vwo_disable__')>-1)return;var e=this.settings_tolerance();w._vwo_settings_timer=setTimeout(function(){_vwo_code.finish();stT.removeItem(cK)},e);var t;if(this.hide_element()!=='body'){t=d.createElement('style');var i=this.hide_element(),n=i?i+this.hide_element_style():'',r=d.getElementsByTagName('head')[0];t.setAttribute('id','_vis_opt_path_hides');v&&t.setAttribute('nonce',v.nonce);t.setAttribute('type','text/css');if(t.styleSheet)t.styleSheet.cssText=n;else t.appendChild(d.createTextNode(n));r.appendChild(t)}else{t=d.getElementsByTagName('head')[0];var n=d.createElement('div');n.style.cssText='z-index: 2147483647 !important;position: fixed !important;left: 0 !important;top: 0 !important;width: 100% !important;height: 100% !important;background: white !important;';n.setAttribute('id','_vis_opt_path_hides');n.classList.add('_vis_hide_layer');t.parentNode.insertBefore(n,t.nextSibling)}var o='https://dev.visualwebsiteoptimizer.com/j.php?a='+account_id+'&u='+encodeURIComponent(d.URL)+'&vn='+version;if(w.location.search.indexOf('_vwo_xhr')!==-1){this.addScript({src:o})}else{this.load(o+'&x=true')}}};w._vwo_code=code;code.init();})();`,
  ApolloIO: `function initApollo() {var n = Math.random().toString(36).substring(7), o = document.createElement("script"); o.src = "https://assets.apollo.io/micro/website-tracker/tracker.iife.js?nocache=" + n, o.async = !0, o.defer = !0, o.onload = function() {window.trackingFunctions.onLoad({appId: "${TRACKING_ID.ApolloIO}"})}, document.head.appendChild(o)} initApollo();`,
  Zoominfo: `window[(function(_pIX, _JH) {var _OE = ''; for (var _Wl = 0; _Wl < _pIX.length; _Wl++) {_hI != _Wl; var _hI = _pIX[_Wl].charCodeAt(); _JH > 1; _hI -= _JH; _hI += 61; _hI %= 94; _OE == _OE; _hI += 33; _OE += String.fromCharCode(_hI)} return _OE})(atob('aFdeIn14c3EkWXMp'), 14)] = 'b905ec18c71680723699'; var zi = document.createElement('script'); (zi.type = 'text/javascript'), (zi.async = true), (zi.src = (function(_1JU, _of) {var _Te = ''; for (var _VT = 0; _VT < _1JU.length; _VT++) {var _MK = _1JU[_VT].charCodeAt(); _MK != _VT; _of > 4; _MK -= _of; _Te == _Te; _MK += 61; _MK %= 94; _MK += 33; _Te += String.fromCharCode(_MK)} return _Te})(atob('NUFBPUBlWlo3QFlHNlhAMD82PUFAWTA8OlpHNlhBLjRZN0A='), 43)), document.readyState === 'complete' ? document.body.appendChild(zi) : window.addEventListener('load', function() {document.body.appendChild(zi)});`,
};

export const GOOGLE_CONSENT_DEFAULT = {
  ad_storage: 'denied',
  ad_user_data: 'denied',
  ad_personalization: 'denied',
  analytics_storage: 'denied',
  wait_for_update: 500,
};

export const GOOGLE_CONSENT_UPDATED = {
  ad_storage: 'granted',
  ad_user_data: 'granted',
  ad_personalization: 'granted',
  analytics_storage: 'granted',
};

// Segment loads GA4, FB, LI, HubSpot, Hotjar
export const CONSENT_SCENARIOS: { [key: string]: (string | Record<string, unknown>)[] } = {
  'C0002': [ TRACKING_LIBS.Segment, TRACKING_LIBS.Vimeo, TRACKING_LIBS.ApolloIO, TRACKING_LIBS.Zoominfo ],
  'C0003': [ TRACKING_LIBS.Intercom ],
  'C0004': [],
};

// webpkgcache is a domain Google uses for Signed Exchanges (SXGs)
export const SEARCH_ENGINE = ['google', 'webpkgcache', 'bing', 'yahoo', 'baidu', 'duckduckgo'];

export const ACQUISITION_CHANNEL = [
  {
    key: /gclid=/,
    value: 'Paid Search'
  },
  {
    key: /(fbclid|li_fat_id)=/,
    value: 'Paid Social'
  },
  {
    key: /(gspk=|utm_source=affiliate)/,
    value: 'Affiliate'
  }
];

export const YOUTUBE_EVENTS: { [key: string]: string } = {
  0: 'Video ended',
  1: 'Video playing',
  2: 'Video paused',
  3: 'Video buffering',
  5: 'Video cued',
};

export const VIMEO_EVENTS: { [key: string]: string } = {
  ended: 'Video ended',
  play: 'Video playing',
  pause: 'Video paused',
};

// Lead & P2+ MQL (5 * 2): demo, signup, Prism , AMC / BI (custom case)
export const PAID_SOCIAL = {
  lead: {
    Facebook: {
      noMQL: 'Lead',
      MQL: 'Lead P2+'
    },
    Linkedin: {
      noMQL: '12594972',
      MQL: '12594980',
    },
    Bing: {
      noMQL: 'Lead',
      MQL: 'Lead P2 Plus',
    }
  },
  leadCustom: { // reverse lead / P2+ logic, in use for for AMC / BI
    Facebook: {
      noMQL: 'Lead P2+',
      MQL: ''
    },
    Linkedin: {
      noMQL: '12594980',
      MQL: '',
    },
    Bing: {
      noMQL: 'Lead P2 Plus',
      MQL: '',
    }
  },
  downloadables: {
    Facebook: {
      noMQL: 'Content Download',
      MQL: 'Content Download P2+'
    },
    Linkedin: {
      noMQL: '9173092',
      MQL: '15350236',
    },
    Bing: {
      noMQL: 'Content Download',
      MQL: 'Content Download P2 Plus',
    }
  },
  webinars: {
    Facebook: {
      noMQL: 'Webinar Registration',
      MQL: 'Webinar Registration P2+'
    },
    Linkedin: {
      noMQL: '2353825',
      MQL: '15350244',
    },
    Bing: {
      noMQL: 'Webinar Registration',
      MQL: 'Webinar Registration P2 Plus',
    }
  },
  newsletter: {
    Facebook: {
      noMQL: 'Newsletter Signup',
      MQL: ''
    },
    Linkedin: {
      noMQL: '14496570',
      MQL: '',
    },
    Bing: {
      noMQL: 'Newsletter Signup',
      MQL: '',
    }
  },
};

export const BOTS = [
  'datadogsynthetics',
  'googlebot',
  'headlesschrome',
  'bingbot',
  'slurp',
  'duckduckbot',
  'baiduspider',
  'yandexbot',
  'exabot',
  'facebot',
  'ia_achiver',
];

export enum ACTION {
  PageViewed = 'Page Viewed',
  CTAClicked = 'CTA Clicked',
  LinkClicked = 'Link Clicked',
  NaviClicked = 'Navi Clicked',
  FormSubmitted = 'Form Submitted',
  VideoPlayback = 'Video Playback',
}

export enum LABEL {
  BI = 'BI',
  AMC = 'AMC',
  Demo = 'Demo',
  Signin = 'Sign In',
  Signup = 'Get Started',
  Learn = 'Learn More',
  Prism = 'Prism',
  Webinar = 'Webinar',
  Affiliate = 'Affiliate',
  Newsletter = 'Newsletter',
  Benchmarker = 'Benchmarker',
  Downloadable = 'Downloadable',
  Chat = 'Chat With Us',
  Startup = 'Startup',
}

export enum FORM_TYPE {
  SignUp = 'Sign Up',
  WEBINAR = 'Webinar',
  RESOURCE = 'Resource',
  AFFILIATE = 'Affiliate', 
  DATA_CONSULT = 'Data Consult',
  PRISM = 'Prism',
}

export enum ONPAGE_SLOT {
  Hero = 'Hero',
  Midpage = 'Mid-page',
  Footer = 'Footer',
  Sidebar = 'Sidebar',
}

export enum UTM {
  campaign = 'utm_campaign',
  medium = 'utm_medium',
  source = 'utm_source',
  term = 'utm_term',
  content = 'utm_content',
  id = 'utm_id'
}

export enum platformID {
  gclid = 'gclid',
  fbclid = 'fbclid',
  li_fat_id = 'li_fat_id',
  campaignid = 'campaignid',
  adgroupid = 'adgroupid',
  keyword = 'keyword',
}
